export default __webpack_public_path__ + "static/media/icon-pin-round.6ac85835.svg";